const theme = {
  COLORS: {
    BACKGROUND: '#000',
    SUB_BACKGROUND: '#121214',
    PRIMARY: '#3D73FF',
    SECONDARY: '#202024',
    ERROR: '#B41313',
    SUCCESS: '#009B22',
    TITLE: '#FFFFFF',
    DESCRIPTION: '#C4C4CC',
    TEXT_DETAILS: '#7C7C8A',
    BACKGROUND_BUTTON: '#201f24'
  },
  IMC_COLORS: {
    baixo: '#B41313', // vermelho
    normal: '#009B22', // verde
    alto: '#FFA500		', // Orange
  },
  FONT_FAMILY: {
    TITLE: 'Inter-Bold',
    TEXT: 'Inter-Regular'
  }
};

export default theme;
